export default __webpack_public_path__ + "static/media/rl-2-rMAX.0aacb99c.jpg";